import { Reducer } from "redux";

import {
  PartnerReferralAction,
  PartnerReferralGetSuccessActionType,
} from "./partner-referral.actions";

export const partnerReferralReducer: Reducer<
  PartnerReferralState,
  PartnerReferralAction
> = (state = {}, action) => {
  switch (action.type) {
    case PartnerReferralGetSuccessActionType:
      return {
        ...state,
        partnerUrl: action.partnerReferral.partnerUrl,
        error: action.partnerReferral.errorMessage,
      };
    default:
      return state;
  }
};

export interface PartnerReferralState {
  partnerUrl?: string | null;
  error?: string | null;
}
